module.exports = __webpack_public_path__ + "static/media/gdpr.1993961a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdpr.svg
// module id = 953
// module chunks = 5